module.exports = __webpack_public_path__ + "img/mastercard.webp";